(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-section"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordions = document.querySelectorAll('.accordion-title');
  
    accordions.forEach(accordion => {
      accordion.addEventListener('click', function() {
        const content = this.nextElementSibling;
        const toggleSign = this.querySelector('.toggle-sign');
  
        if (content.style.display === "block") {
          content.style.display = "none";
          toggleSign.textContent = '+';
        } else {
          content.style.display = "block";
          toggleSign.textContent = '-';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
